// extracted by mini-css-extract-plugin
module.exports = {"navigation":"WaitFish_navigation__dK8n6","repeatBTN":"WaitFish_repeatBTN__RE515"};